var map = {
	"./#03CEA4/currencyEle.svg": "d070",
	"./#3777FF/currencyEle.svg": "ca62",
	"./#EE964B/currencyEle.svg": "dd0f",
	"./#F754A2/currencyEle.svg": "48ae",
	"./#FF495C/currencyEle.svg": "6657"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "41c0";